module.exports = __webpack_public_path__ + "img/anli02.873d07d9.png";